import { ApiSimpleComponent } from "@incendium/api";
import {
  deleteSharedComponentBlock,
  useSharedComponentBlocks,
} from "features/sharedComponentBlocks";
import { BlocksList } from "features/sharedComponentBlocks/components/BlocksList";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

function SharedComponentBlocksPage() {
  const { blocks, setBlocks, fetched } = useSharedComponentBlocks();
  const history = useHistory();

  const newBlock = useCallback(() => {
    history.push(`./shared-component-blocks/new`);
  }, [history]);

  const editBlock = useCallback(
    (block: ApiSimpleComponent) => {
      // Use externalId for shared blocks (MongoDB ObjectID string)
      const blockId = block.externalId || block.id?.toString();
      history.push(`./shared-component-blocks/${blockId}`);
    },
    [history]
  );

  const onDelete = useCallback(
    async (block: ApiSimpleComponent): Promise<string> => {
      // Use externalId for shared blocks (MongoDB ObjectID string)
      const blockId = block.externalId || block.id?.toString() || "";
      await deleteSharedComponentBlock(blockId);
      return `Block ${block.name} deleted`;
    },
    []
  );

  return (
    <BlocksList
      blocks={blocks}
      setBlocks={setBlocks}
      fetched={fetched}
      title="Shared Component Blocks"
      newButtonLabel="New Shared Block"
      emptyMessage="You don't have any Shared Component Blocks yet."
      emptySubMessage="Click the button below to get started!"
      onNew={newBlock}
      onEdit={editBlock}
      onDelete={onDelete}
    />
  );
}

export default SharedComponentBlocksPage;

